// usuario.service.ts
import { Injectable } from "@angular/core";
import { ApiService } from "./api.service"; // Ajuste o caminho conforme necessário
import { lastValueFrom } from "rxjs";
import { from } from "rxjs";
import { showNotification } from "./../utils/notifications/showNotification";
import Swal from "sweetalert2";
import { getParameterByName, isNewClientOrUser, singleExecution } from "../utils/others/others";
import { NavbarComponent } from "../shared/navbar/navbar.component";

type recomendations_to_recommend = {
  recommendation: string;
  should_recommend: boolean;
  solution?: string;
  product?: string;
  description?: string;
  value?: number;
  periodicity?: string;
  report_id?: string;
  order?: number;
  status?: string;
};

@Injectable({
  providedIn: "root",
})
export class TakeLists {
  showClientSelector() {
    throw new Error("Method not implemented.");
  }

  constructor(private _api: ApiService) { }

  /* -- ----- Bases ----- -- */ // Início
  // A Base é uma chamada padrão de get na API para facilitar e
  // reutilizar o código
  async getBase(endpoint, payload = {}, lastUpdate?: string) {
    let skip = 0;
    const limit = 100;
    let result: any[] = [];
    let hasMore = true;

    while (hasMore) {
      try {
        // Faz apenas uma requisição por vez
        const response = await lastValueFrom(
          this._api.getTypeRequest(
            endpoint,
            Object.assign(
              {},
              {
                skip: skip,  // Usar o skip atual para a página
                limit: limit,
                ...(lastUpdate ? { last_updated_at: lastUpdate } : {}),  // Adicionar lastUpdate à query
              },
              payload,
            ),
          ),
        );

        // Verifica se a resposta não está vazia
        if (Array.isArray(response) && response.length > 0) {
          result = result.concat(response);  // Adiciona a resposta ao resultado

          // Atualiza o skip para a próxima página
          skip += limit;

          // Verifica se a resposta é menor que o limite para parar o loop
          if (response.length < limit) {
            hasMore = false;
          }
        } else {
          hasMore = false;  // Se a resposta estiver vazia, parar o loop
        }
      } catch (error) {
        console.error("Ocorreu um erro ao buscar " + endpoint, error);
        result = [];
        break;
      }
    }
    return result;
  }


  /* -- ----- Bases ----- -- */ //Fim

  /* -- ----- Dashboard ----- -- */ // Início
  async getCalculation(reportId) {

    if (typeof reportId === "undefined" || reportId === null) {
      reportId = "";
      return {};
    };
    let endpoint = 'calculation-results/' + reportId;
    var result = {};

    try {
      const response: any = await lastValueFrom(
        this._api.getTypeRequest(endpoint, {})
      );
      if (response.report_id === reportId) {
        return response;
      } else {
        showNotification(
          "bottom",
          "left",
          "danger",
          "Nenhum dado foi retornado. Possivelmente você não tem acesso à esse estudo" +
          endpoint +
          "<br> Por favor, contate o administrador!",
        );
        Swal.close();
        return {};
      };
    } catch {
      showNotification(
        "bottom",
        "left",
        "danger",
        "Nenhum dado foi retornado. Possivelmente você não tem acesso à esse estudo ou ele não existe" +
        endpoint +
        "<br> Por favor, contate o administrador!",
      );
      Swal.close();
    };

  };
  async getReport(reportId) {

    if (typeof reportId === "undefined" || reportId === null) {
      reportId = "";
      return {};
    };
    let endpoint = 'reports/' + reportId;

    try {
      const response: any = await lastValueFrom(
        this._api.getTypeRequest(endpoint, {})
      );
      if (response.id === reportId) {
        return response;
      } else {
        showNotification(
          "bottom",
          "left",
          "danger",
          "Nenhum dado foi retornado. Possivelmente você não tem acesso à esse estudo" +
          endpoint +
          "<br> Por favor, contate o administrador!",
        );
        Swal.close();
        return {};
      };
    } catch {
      showNotification(
        "bottom",
        "left",
        "danger",
        "Nenhum dado foi retornado. Possivelmente você não tem acesso à esse estudo ou ele não existe" +
        endpoint +
        "<br> Por favor, contate o administrador!",
      );
      Swal.close();
    };

  };
  async getUserByReport(reportId) {
    if (typeof reportId === "undefined" || reportId === null) {
      reportId = "";
      return {};
    };
    const report = await this.getReport(reportId);

    let endpoint = 'users/' + report.client_id;

    try {
      const response: any = await lastValueFrom(
        this._api.getTypeRequest(endpoint, {})
      );
      if (response.id === report.client_id) {
        return response;
      } else {
        showNotification(
          "bottom",
          "left",
          "danger",
          "Nenhum dado foi retornado. Possivelmente você não tem acesso ao cliente desse estudo " +
          endpoint +
          "<br> Por favor, contate o administrador!",
        );
        Swal.close();
        return {};
      };
    } catch {
      showNotification(
        "bottom",
        "left",
        "danger",
        "Nenhum dado foi retornado. Possivelmente você não tem acesso à esse estudo, ao cliente ou ele não existe " +
        endpoint +
        "<br> Por favor, contate o administrador!",
      );
      Swal.close();
    };
  };
  /* -- ----- Dashboard ----- -- */ // Fim

  /* -- ----- Estudos ----- -- */ //Início
  // Aqui são os dados dos estudos
  private async getReportsCore(): Promise<any[]> {
    let lastUpdate = localStorage.getItem("reportsLastUpdate") || undefined;
    const storedReports = JSON.parse(localStorage.getItem("reports") || "[]");
    if (storedReports.length < 10) {
      lastUpdate = undefined; // Se o localStorage estiver vazio, não usar lastUpdate
    }

    const reports = await this.getBase("reports/", {}, lastUpdate);

    // Substituir ou adicionar relatórios novos no localStorage
    const updatedReports = storedReports.map((storedReport) => {
      const newReport = reports.find((report) => report.id === storedReport.id);
      return newReport ? newReport : storedReport;
    });

    // Adicionar relatórios novos que não estavam no localStorage
    reports.forEach((report) => {
      if (!updatedReports.some((storedReport) => storedReport.id === report.id)) {
        updatedReports.push(report);
      }
    });

    // Atualizar o localStorage
    localStorage.setItem("reports", JSON.stringify(updatedReports));
    localStorage.setItem("reportsLastUpdate", new Date().toISOString());

    return updatedReports;
  }

  public getReports = singleExecution(async () => {
    return this.getReportsCore();
  });

  async getGerenciamentoEstudo(report_id: string) {
    console.log("getGerenciamentoEstudo");

    let result: {} = {};
    let endpoint = "reports/" + report_id;

    console.log(endpoint);
    // Estudo Novo
    if (report_id === null) {
      return {
        report: {},
        living_standards: [],
      };
    }

    // Pegando dados do estudo
    try {
      console.log(report_id);
      const response: any = await lastValueFrom(
        this._api.getTypeRequest(endpoint, {}),
      );
      if (response.id === report_id) {

        result["report"] = response;
      } else {
        showNotification(
          "bottom",
          "left",
          "danger",
          "Nenhum dado foi retornado.<br>Possivelmente você não tem acesso à esse estudo" +
          endpoint +
          "<br> Por favor, contate o administrador!",
        );
        return {};
      }
    } catch (error) {
      console.error(
        "Ocorreu um erro ao buscar dados do report\n endpoint:" + endpoint,
        error,
      );
      showNotification(
        "bottom",
        "left",
        "danger",
        "Houve um erro ao carregar os dados desse report. <br> Endpoint:" +
        endpoint +
        "<br> Por favor, contate o administrador!",
      );
      return {};
    }

    // Pegando dados de Informações profissionais
    const living_standards = await this.getBase("living-standards/", {
      report_id: report_id,
    });
    result["living_standards"] = await living_standards;

    return result;
  }
  /* -- ----- Estudos ----- -- */ //Fim

  /* -- ----- Recomendações ----- -- */ //Início
  async getGerenciamentoRecomendacao(estudo_id: string) {
    if (!estudo_id) {
      console.log("Estudo não encontrado");
      showNotification(
        "bottom",
        "left",
        "danger",
        "Id do estudo não foi encontrado.<br> Por favor, contate o administrador!",
      );
      return {};
    }
    let result: {} = {};

    try {
      // Pegando dados de recomendação
      const recomendations = await this.getBase("recommendations/", {
        report_id: estudo_id,
      });
      result["recomendations"] = recomendations;

      // Pegando dados de solutions em recomendação
      result["solutions"] = await [
        { name: "Proteção e Sucessão", id: "protection and succession" },
        { name: "Profissional", id: "professional" },
        { name: "Financeira e Patrimonial", id: "finance and asset" },
      ];

      result["products"] = await [
        { name: "Investimento Doméstico", id: "domestic investment" },
        { name: "Investimento Internacional", id: "international investment" },
        { name: "Seguro", id: "insurance" },
        { name: "Sucessão", id: "succession" },
        { name: "Consórcio", id: "consortium" },
        { name: "Crédito Imobiliário", id: "real estate loans" },
        { name: "Ação", id: "stock" },
        { name: "Proteção Patrimonial", id: "asset protection" },
        { name: "Estudo INSS", id: "inss study" },
        { name: "Educação a Sucessores", id: "education to sucessors" },
        { name: "Previdência Privada", id: "private pension" }
      ];

      result["status"] = await [
        { name: "Pendente", id: "pending" },
        { name: "Faz Sentido", id: "makes sense" },
        { name: "Não Faz Sentido", id: "does not make sense" },
        { name: "Aprovado", id: "accepted" },
      ];

      result["periodicities"] = await [
        { name: 'Única', id: 'unique' },
        { name: 'Sem Periodicidade', id: 'no periodicity' },
        { name: "Mensal", id: "monthly" },
        { name: "Bimestral", id: "bimonthly" },
        { name: "Trimestral", id: "quarterly" },
        { name: "Semestral", id: "semesterly" },
        { name: "Anual", id: "annually" },
      ];

      result["descriptions"] = await [
        {
          solution: "finance and asset",
          value:
            "Realocar a carteira global de investimentos para aumentar a probabilidade de atingir os objetivos identificados no estudo",
        },
        {
          solution: "finance and asset",
          value:
            "Alocar os recursos em investimentos para aumentar a probabilidade de atingir os objetivos identificados no estudo",
        },
        {
          solution: "finance and asset",
          value:
            "Estudar a diversificação geográfica da sua carteira de investimentos",
        },
        {
          solution: "finance and asset",
          value: "Aumentar a exposição aos ativos líquidos",
        },
        {
          solution: "finance and asset",
          value: "Aumentar liquidez do seu patrimônio",
        },
        {
          solution: "finance and asset",
          value: "Diminuir a exposição aos ativos imobilizados",
        },
        {
          solution: "finance and asset",
          value:
            "Conversar com nosso especialista em crédito imobiliário (financiamento/home equity e consórcio)",
        },
        {
          solution: "finance and asset",
          value: "Manter o crédito imobiliário atual",
        },
        {
          solution: "finance and asset",
          value: "Liquidar o crédito imobiliário atual",
        },
        {
          solution: "finance and asset",
          value:
            "Estudar a diversificação geográfica da sua carteira de investimentos",
        },
        {
          solution: "finance and asset",
          value:
            "Conversar com nosso especialista da área Corporate para estudar soluções para o(s) caso(s) em questão",
        },
        {
          solution: "finance and asset",
          value: "Focar na capacidade de poupança",
        },
        {
          solution: "finance and asset",
          value: "Focar na consolidação patrimonial",
        },
        {
          solution: "finance and asset",
          value: "Focar no aumento patrimonial",
        },
        {
          solution: "protection and succession",
          value:
            "Conversar com nosso especialista para entender a necessidade de proteção e/ou sucessão patrimonial",
        },
        {
          solution: "protection and succession",
          value: "Cancelar a apólice de seguro atual",
        },
        {
          solution: "protection and succession",
          value: "Manter a atual apólice de seguro",
        },
        {
          solution: "professional",
          value:
            "Entender no detalhe o caso para tomar a decisão da transição em questão com a maior convicção possível",
        },
        {
          solution: "protection and succession",
          value:
            "Contratar estudo previdenciário - INSS"
        },
        {
          solution: "professional",
          value:
            "Contratar estudo previdenciário - INSS"
        },
        {
          solution: "finance and asset",
          value:
            "Contratar estudo previdenciário - INSS"
        },
      ];



      return result;
    } catch (error) {
      result = {
        recomendations: [],
        solutions: [],
        products: [],
        periodicities: [],
      };

      return result;
    }
  }
  /* -- ----- Recomendações ----- -- */ //Fim

  /* -- ----- Clientes ----- -- */ //Início
  // Aqui são os dados dos clientes
  async getGerenciamentoCliente(client_id: String) {
    let result: {} = {};
    let endpoint = "users/" + client_id;

    // Cliente Novo
    if (client_id === null) {
      return {
        user: {},
        dependants: [],
        educations: [],
        professional_informations: [],
        other_incomes: [],
        assets: [],
        liabilities: [],
        insurances: [],
        life_projects: [],
      };
    }

    // Pegando dados do User
    try {
      const response: any = await lastValueFrom(
        this._api.getTypeRequest(endpoint, {}),
      );

      if (response.id === client_id) {
        result["user"] = response;
      } else {
        showNotification(
          "bottom",
          "left",
          "danger",
          "Nenhum dado foi retornado. Possivelmente você não tem acesso à esse cliente" +
          endpoint +
          "<br> Por favor, contate o administrador!",
        );
        return {};
      }
    } catch (error) {
      console.error(
        "Ocorreu um erro ao buscar dados do user \n endpoint:" + endpoint,
        error,
      );
      showNotification(
        "bottom",
        "left",
        "danger",
        "Houve um erro ao carregar os dados desse cliente. <br> Endpoint:" +
        endpoint +
        "<br> Por favor, contate o administrador!",
      );
    }

    // Pegando dados do Dependente
    const dependants = await this.getBase("dependants/", {
      user_id: client_id,
    });
    result["dependants"] = await dependants; // Garantir que a promessa seja resolvida

    // Pegando dados de Educação
    const educationPromises = dependants.map((dependant) =>
      this.getBase("educations/", { dependant_id: dependant.id }),
    );
    const educations = await Promise.all(educationPromises); // Olhando todos os dependantes 1 a 1
    result["educations"] = educations.flat(); // só dando merge nos arrays de array

    const [
      professional_informations,
      other_incomes,
      assets,
      liabilities,
      insurances,
      life_projects,
    ] = await Promise.all([
      this.getBase("professional-informations/", { user_id: client_id }),
      this.getBase("other-incomes/", { user_id: client_id }),
      this.getBase("assets/", { user_id: client_id }),
      this.getBase("liabilities/", { user_id: client_id }),
      this.getBase("insurances/", { user_id: client_id }),
      this.getBase("life-projects/", { user_id: client_id }),
    ]);

    result["professional_informations"] = professional_informations;
    result["other_incomes"] = other_incomes;
    result["assets"] = assets;
    result["liabilities"] = liabilities;
    result["insurances"] = insurances;
    result["life_projects"] = life_projects;

    return result;
  }

  private usersPromise: Promise<any> | null = null;

  // 2) “Empacotamos” a getUsersCore para que só rode uma vez por vez
  public getUsers = singleExecution(async () => {
    return this.getUsersCore();
  });

  private async getUsersCore(): Promise<any[]> {
    let lastUpdate = localStorage.getItem("usersLastUpdate") || undefined;
    const storedUsers = JSON.parse(localStorage.getItem("users") || "[]");
    if (storedUsers.length < 10) {
      lastUpdate = undefined; // Se o localStorage estiver vazio, não usar lastUpdate
    }

    const users = await this.getBase("users/", {}, lastUpdate);

    // Substituir ou adicionar usuários novos no localStorage
    const updatedUsers = storedUsers.map((storedUser) => {
      const newUser = users.find((user) => user.id === storedUser.id);
      return newUser ? newUser : storedUser;
    });
    // Adicionar novos
    users.forEach((user) => {
      if (!updatedUsers.some((u) => u.id === user.id)) {
        updatedUsers.push(user);
      }
    });
    // Atualizar localStorage
    localStorage.setItem("users", JSON.stringify(updatedUsers));
    localStorage.setItem("usersLastUpdate", new Date().toISOString());

    return updatedUsers;
  }

  async getIrDeclarations() {
    const irDeclarations = this.getBase("ir-declarations/");
    return irDeclarations;
  }

  async getGenders() {
    const genders = this.getBase("genders/");
    return genders;
  }

  async getMaritalStatus() {
    const maritalStatus = this.getBase("marital-status/");
    return maritalStatus;
  }

  async getPropertyRegimes() {
    const propertyRegimes = this.getBase("property-regimes/");
    return propertyRegimes;
  }

  async getEducationType() {
    return [
      { name: "Creche", id: "nursery" },
      { name: "Pré-Escola", id: "pre school" },
      { name: "Fundamental", id: "elementary school" },
      { name: "Médio", id: "high school" },
      { name: "Superior", id: "university" },
      { name: "Pós-Graduação", id: "postgraduate" },
    ];
  }

  async getAssetsConsumption() {
    console.log("getAssetsConsumption");
    return [
      { name: "Consumo Parcial", id: "partial" },
      { name: "Consumo Total", id: "total" },
      { name: "Sem consumo", id: "no consumption" },
    ];
  }

  async getKinships() {
    const kinships = this.getBase("kinships/");
    return kinships;
  }

  async getVariableSalaryPeriodicity() {
    return [
      { name: "Mensal", id: "monthly" },
      { name: "Bimestral", id: "bimonthly" },
      { name: "Trimestral", id: "quarterly" },
      { name: "Semestral", id: "semesterly" },
      { name: "Anual", id: "annually" },
    ];
  }

  async getEmploymentRelationships() {
    const employmentRelationships = this.getBase(
      "employment-relationships/",
    );
    return employmentRelationships;
  }

  async getAssetsType() {
    return [
      { name: "Investimento Doméstico", id: "domestic investment" },
      { name: "Imóvel", id: "property" },
      { name: "Participação Societária", id: "equity participation" },
      { name: "Previdência Privada", id: "private pension" },
      { name: "Terreno", id: "ground" },
      { name: "Mútuo", id: "mutual" },
      { name: "Investimento Internacional", id: "international investment" },
      { name: "Outros", id: "others" },
      { name: "Precatório", id: "precatory" },
      { name: "Direito Creditório", id: "credit law" },
      { name: "Direito Trabalhista", id: "labor law" },
      { name: "Depósitos Judiciais Esquecidos", id: "forgotten court deposits" },
      { name: "Automóvel", id: "car" },
    ];
  }

  async getGoals() {
    return [
      { name: "Independência Financeira", id: "financial independence" },
      { name: "Qualidade de Vida", id: "life quality" },
    ];
  }

  async getPfPj() {
    return [
      { name: "PF", id: "pf" },
      { name: "PJ", id: "pj" },
    ];
  }

  async getPensionTaxRegime() {
    return [
      { name: "Progressivo", id: "progressive" },
      { name: "Regressivo", id: "regressive" },
    ];
  }

  async getPensionType() {
    return [
      { name: "VGBL", id: "vgbl" },
      { name: "PGBL", id: "pgbl" },
    ];
  }

  async getLiabilityTypes() {
    const liabilityTypes = this.getBase("liability-types/");
    return liabilityTypes;
  };

  async getLifeProjectTypes() {
    const lifeProjectTypes = this.getBase("life-project-types/");
    return lifeProjectTypes;
  }

  async getInsuranceTypes() {
    const insuranceTypes = this.getBase("insurance-types/");
    return insuranceTypes;
  }

  async getInsuranceCompanies() {
    const insuranceCompanies = this.getBase("insurance-companies/");
    return insuranceCompanies;
  }

  async takePendents() {
    const pendents = await this.getBase("recommendations/all_notifications/");
    return pendents;
  }

  async createRecommendedRecomendations(report_id, calculation) {
    console.log("Criando recomendação automática");
    try {
      const recomendations_management: any = await this.getGerenciamentoRecomendacao(report_id);
      const current_recommendations = recomendations_management.recomendations;
      const user = await this.getUserByReport(report_id);
      const life_projects = await this.getBase("life-projects/", { user_id: user.id }) ?? []


      let should_have_sucession_education: recomendations_to_recommend = {
        recommendation: "should_have_sucession_education",
        should_recommend: calculation.should_have_sucession_education,
        solution: "protection and succession",
        product: "education to sucessors",
        description: "Conversar com nosso especialista sobre estratégias de educação financeira e patrimonial para preparar seus herdeiros, que estão ingressando na fase produtiva da vida, a lidar com responsabilidades e decisões relacionadas ao patrimônio familiar.",
        value: 0,
        periodicity: "unique",
        report_id: report_id,
        status: "pending",
      }

      let should_have_consortium_for_child: recomendations_to_recommend = {
        recommendation: "should_have_consortium_for_child",
        should_recommend: calculation.should_have_consortium_for_child,
        solution: "finance and asset",
        product: "consortium",
        description: "Considerar o uso de consórcio como alternativa de planejamento futuro para seu(s) filho(s), aproveitando a janela de tempo até atingirem a maioridade.",
        value: 0,
        periodicity: "unique",
        report_id: report_id,
        status: "pending",
      };

      let should_have_inss_study: recomendations_to_recommend = {
        recommendation: "should_have_inss_study",
        should_recommend: calculation.should_have_inss_study,
        solution: "finance and asset",
        product: "inss study",
        description: "Solicitar um estudo previdenciário para entender se haverá ou não benefício do INSS, e assim aprofundar o planejamento para alcançar sua independência financeira plena.",
        value: 3500,
        periodicity: "unique",
        report_id: report_id,
        status: "pending",
      };

      let should_have_international_investment: recomendations_to_recommend = {
        recommendation: "should_have_international_investment",
        should_recommend: calculation.should_have_international_investment,
        solution: "finance and asset",
        product: "international investment",
        description: "Diversificar a carteira com investimentos internacionais, ampliando a exposição a diferentes economias e reduzindo riscos locais.",
        value: Math.round((calculation.asset_distribution["domestic investment"] ?? 0) * 0.1),
        periodicity: "unique",
        report_id: report_id,
        status: "pending",
      };


      let should_have_consortium_for_property: recomendations_to_recommend = {
        recommendation: "should_have_consortium_for_property",
        should_recommend: calculation.should_have_consortium_for_property,
        solution: "finance and asset",
        product: "consortium",
        description: "Avaliar a substituição do atual financiamento por um consórcio, visando otimizar taxas e prazos. <br><br>#Recomendada Por IA",
        value: (calculation.liability_distribution["1"] ?? 0),
        periodicity: "unique",
        report_id: report_id,
        status: "pending",
      };

      let should_have_sucession_protection: recomendations_to_recommend = {
        recommendation: "should_have_sucession_protection",
        should_recommend: calculation.should_have_sucession_protection,
        solution: "protection and succession",
        product: "insurance",
        description: "Contratar um seguro de vida para garantir a proteção financeira da família em caso de imprevistos.",
        value: ((1 - (calculation.protect_thermometer ?? 0)) * (calculation.pf_posthumous + calculation.pj_posthumous)),
        periodicity: "unique",
        report_id: report_id,
        status: "pending",
      };

      let should_have_consortium_for_dream: recomendations_to_recommend = {
        recommendation: "should_have_consortium_for_dream",
        should_recommend: calculation.should_have_consortium_for_dream,
        solution: "finance and asset",
        product: "consortium",
        description: "Considerar o uso de consórcio como alternativa de planejamento futuro para o sonho de adquirir um imóvel.",
        value: life_projects.reduce((total, project) => {
          if ([2, 3, 4].includes(project.type_id)) {
            const parcelas = (project.installment_amount ?? 0) * (project.installments_quantity ?? 0);
            const entrada = project.entry_cost ?? 0;
            return total + parcelas + entrada;
          }
          return total;
        }, 0),
        periodicity: "unique",
        report_id: report_id,
        status: "pending",
      };

      let checks: recomendations_to_recommend[] = [
        should_have_consortium_for_child,
        should_have_consortium_for_property,
        should_have_consortium_for_dream,
        should_have_international_investment,
        should_have_inss_study,
        should_have_sucession_protection,
        should_have_sucession_education,
      ];

      let number_of_recommendations = current_recommendations.length ?? 0;
      let number_of_recommendations_added = 0;

      for (let check of checks) {
        console.log(check);
        if (check.should_recommend) {
          for (const recommendation of current_recommendations) {
            if (recommendation.associated_engine == check.recommendation) {
              check.should_recommend = false;
            };

            if (['should_have_international_investment', 'should_have_sucession_education', 'should_have_inss_study'].includes(check.recommendation)) {
              if ((check.product ?? '') == (recommendation.product ?? '')) {
                check.should_recommend = false;
              }
            };
          }

          if (check.should_recommend) {
            console.log("Inciando criação de recomendação", check.recommendation);
            const recomend_payload = {
              solution: check.solution,
              product: check.product,
              description: check.description,
              value: check.value,
              periodicity: check.periodicity,
              report_id: report_id,
              order: number_of_recommendations + 1,
              status: check.status,
              associated_engine: check.recommendation,
            };

            console.log(recomend_payload);

            number_of_recommendations += 1;

            const request = this._api.postTypeRequestJson('recommendations', recomend_payload);
            const response: any = await lastValueFrom(request);
            console.log('recomendation criada com sucesso ' + response.id);
            number_of_recommendations_added += 1;
          }
        }
      };

      if (number_of_recommendations_added > 0) {
        showNotification("bottom", "left", "success",
          number_of_recommendations_added == 1 ?
            (number_of_recommendations_added + " recomendação foi sugerida automaticamente para o estudo!") :
            (number_of_recommendations_added + " recomendações foram sugeridas automaticamente para o estudo!")

        );
      };

    } catch (error) {
      console.error("Ocorreu um erro ao criar as recomendações", error);
      showNotification(
        "bottom",
        "left",
        "danger",
        "Ocorreu um erro ao criar as recomendações sugeridas. <br> Por favor, contate o administrador!",
      )
    };
  };

}

